import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import authService from './services/authService';

// Configurer le token d'authentification au démarrage
const token = localStorage.getItem('token');
if (token) {
  authService.setAuthToken(token);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
